// @flow
import React, {type Node} from 'react'
import {type RelayFragmentContainer, createFragmentContainer, graphql} from 'react-relay'

import CSRFToken from 'utils/MiscUtils/CSRFToken'
import SectionItem from 'components/SideBar/ui/SectionItem'
import type {
  SignoutButton_viewer as Viewer,
} from './__generated__/SignoutButton_viewer.graphql'

const signout = (signoutPath: string) => () => {
  fetch(signoutPath, {
    method: 'DELETE',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': CSRFToken(),
    },
    credentials: 'same-origin',
  })
    .then((response) => {
      if (response.status === 204)
        window.location.reload()
    })
}

type Props = $ReadOnly<{
  viewer: Viewer,
}>

function SignoutButton({viewer: {routes}}: Props): Node {
  return (
    <SectionItem
      title={I18n.t('side_nav.user_section.sign_out')}
      onClick={signout(routes.signoutPath)}
    />
  )
}

export default (createFragmentContainer(SignoutButton, {
  viewer: graphql`
    fragment SignoutButton_viewer on Person {
      routes {
        signoutPath
      }
    }
  `,
}): RelayFragmentContainer<typeof(SignoutButton)>)
